import { useState } from 'react';
import { useAdmin } from '../../context/AdminContext';
import styles from './Admin.module.css';

export const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAdmin();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const success = login(password);

    if (!success) {
      setError('Nesprávné heslo!');
    }

    setLoading(false);
  };

  return (
    <form className={styles.loginForm} onSubmit={handleSubmit}>
      <h1 className={styles.title}>Admin Panel</h1>
      <p className={styles.subtitle}>Zadej heslo pro přístup</p>

      {error && <div className={styles.error}>{error}</div>}

      <div className={styles.formGroup}>
        <label htmlFor="password" className={styles.label}>
          Heslo
        </label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className={styles.input}
          placeholder="Zadej heslo..."
          disabled={loading}
          autoFocus
        />
      </div>

      <button type="submit" className={styles.submitBtn} disabled={loading}>
        {loading ? 'Ověřuji...' : 'Přihlásit se'}
      </button>
    </form>
  );
};
